import { ClientEnum } from '../enums/app.enum';
import { IInsurersDetails } from '../interfaces/insurer.interface';

export const AppClientDetails = {
  CTRL: {
    domain: 'za.co.takectrl.app',
    display_name: 'Ctrl',
    display_name_full: 'Ctrl',
    client_name_key: 'ctrl',
    enum_name: ClientEnum.CTRL,
    static_wallet_page_image: false,
    static_refer_friend_page_image: false,
    show_cover_start_date: true,
    static_landing: true,
    intercom: true,
    client_type: 'direct',
    show_recommended: true,
    can_download_app: false,
    otp_alt_call_options: false,
    app_client_specific_text_settings: {
      added_benefits_text: 'King Price and MiWay',
      quote_complete_header_text: 'Welcome to the CTRL family',
      quote_complete_button_text: 'OK, thanks',
    },
    app_client_specific_colours: {
      quote_percentage_circle_recommended_color: '#00B761',
      quote_percentage_circle_not_recommended_color_svga_element: '#ff3a30',
      titleColor: '#0d1317',
    },
    landing_videos: {
      step_one_video_url: '',
      step_two_video_url: '',
      step_three_video_url: '',
      step_four_video_url: '',
    },
    insurer_contact_details: new Array<IInsurersDetails>(),
  },
  MOMENTUM: {
    domain: 'za.co.consultinsure',
    domainReversed: 'consultinsure.co.za',
    display_name: 'Momentum',
    display_name_full: 'Momentum Consult',
    client_name_key: 'momentum',
    enum_name: ClientEnum.MOMENTUM,
    static_wallet_page_image: true,
    static_refer_friend_page_image: false,
    show_cover_start_date: true,
    static_landing: false,
    intercom: true,
    client_type: 'direct',
    show_recommended: true,
    can_download_app: true,
    otp_alt_call_options: false,
    app_client_specific_text_settings: {
      added_benefits_text: 'MiWay',
      quote_complete_header_text: 'Welcome to the family',
      quote_complete_button_text: 'I agree',
    },
    app_client_specific_colours: {
      quote_percentage_circle_recommended_color: '#00B761',
      quote_percentage_circle_not_recommended_color_svga_element: '#e11b22',
      titleColor: '#4d4d4f',
    },
    landing_videos: {
      step_one_video_url: 'https://ctc-shared-external.s3.eu-west-1.amazonaws.com/videos/momentum/stepOne.mp4',
      step_two_video_url: 'https://ctc-shared-external.s3.eu-west-1.amazonaws.com/videos/momentum/stepTwo.mp4',
      step_three_video_url: 'https://ctc-shared-external.s3.eu-west-1.amazonaws.com/videos/momentum/stepThree.mp4',
      step_four_video_url: 'https://ctc-shared-external.s3.eu-west-1.amazonaws.com/videos/momentum/stepFour.mp4',
    },
    insurer_contact_details: new Array<IInsurersDetails>(),
  }
};
